import { useTranslation } from "react-i18next";
import { Box, Divider, Typography } from "@mui/material";

import { ServiceRequest } from "../../../types/service.type";

import ServicePriceFields from "./ServicePriceFields";
import ServiceDetailsFields from "./ServiceDetailsFields";
import ServicePaymentDueDate from "./ServicePaymentDueDate";

const ContractDetails = ({ serviceRequest, isLoading }: { serviceRequest?: ServiceRequest; isLoading: boolean }) => {
  const { t } = useTranslation("goService", { keyPrefix: "createContractPage" });

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("contractDetails")}</Typography>
      <Box sx={styles.stepContainer}>
        <Box sx={{ ...styles.step, borderColor: "var(--Brand-600, #008B07)" }} />
        <Box sx={styles.step} />
      </Box>
      <Divider flexItem sx={styles.divider} />
      <ServiceDetailsFields
        serviceName={serviceRequest?.service.name}
        serviceCode={serviceRequest?.service.serviceNumber}
        isDataLoading={isLoading}
      />
      <Divider flexItem />
      <ServicePriceFields
        serviceCurrency={serviceRequest?.service.paymentConfig.currency!}
        isDataLoading={isLoading}
        serviceType={serviceRequest?.service.paymentConfig.type!}
      />
      {serviceRequest?.service.paymentConfig.type === "fixed" && <ServicePaymentDueDate />}
    </Box>
  );
};

export default ContractDetails;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "16px",
  },
  title: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  stepContainer: {
    width: "100%",
    display: "flex",
    gap: "8px",
    paddingBottom: "16px",
  },
  step: {
    flex: 1,
    borderTop: "4px solid var(--Gray-200, #E4E7EC)",
  },
  divider: {
    mx: "-20px",
  },
};
